var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BondCover-Flow_Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_x5F_BondCover_x5F_Draft-2",
    transform: "translate(-40.000000, -671.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_-copy",
    transform: "translate(20.000000, 649.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st0",
    d: "M29,42.1h2v-3c0-0.5,0.4-1,1-1c0.6,0,1,0.5,1,1v3h2v-7h-6V42.1z M23,42.1v-7.5 c-0.6-0.5-1-1.2-1-2c0-0.2,0-0.3,0.1-0.5c-1.3-0.1-1.4-0.8-0.2-1.7l9.3-6.3c0.5-0.3,1.2-0.3,1.7,0l9.3,6.3 c1.3,0.9,1.2,1.6-0.2,1.7c0,0.2,0.1,0.3,0.1,0.5c0,0.8-0.4,1.5-1,2v7.5h2c0.6,0,1,0.4,1,1c0,0.6-0.5,1-1,1H21c-0.6,0-1-0.4-1-1 c0-0.6,0.5-1,1-1H23z M31,30.1v-1c0-0.6,0.4-1,1-1c0.6,0,1,0.5,1,1v1h5L32,26l-6,4.1H31z M25,35.1v7h2v-7H25z M37,35.1v7h2v-7H37 z M24,32.1v1h16v-1H24z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.91c3e4c454794aa70cd8efc49dd0ea93.svg";
export { ForwardRef as ReactComponent };